import { useEffect, useState } from "react";
import { useTranslation } from "../../context/TranslationContext";
import Button from "../ds/Button";
import Modal from "../ds/Modal";
import TextField from "../ds/TextField";
import { APP_FILLED, PlatformLogo } from "./shared";

/** Links a social account by its profile address or @username. */
const ConnectAccountModal = ({ platform, saving = false, onSave, onClose }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");

  useEffect(() => setValue(""), [platform]);

  const submit = (event) => {
    event.preventDefault();
    if (value.trim()) onSave(value);
  };

  return (
    <Modal
      open={Boolean(platform)}
      onClose={onClose}
      title={platform ? t("campaignFlow.connectPlatform", { platform: platform.name }) : ""}
      description={t("campaignFlow.connectWhy")}
      closeLabel={t("common.close")}
    >
      <form onSubmit={submit} className="flex flex-col gap-space-20">
        <TextField
          label={t("campaignFlow.profileLabel")}
          placeholder={t("campaignFlow.connectPlaceholder")}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          icon={<PlatformLogo platform={platform} size={18} />}
          autoFocus
        />
        <div className="flex justify-end gap-space-12">
          <Button variant="gray" onClick={onClose} disabled={saving}>
            {t("common.cancel")}
          </Button>
          <Button type="submit" className={value.trim() ? APP_FILLED : ""} disabled={!value.trim()} loading={saving}>
            {t("campaignFlow.connect")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ConnectAccountModal;
